/**
 * Utilidades compartidas: formato PEN, classNames, parsing de Decimal-as-string.
 */

/** Concat condicional de clases Tailwind. Reemplaza `clsx` para evitar dep extra. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}

const NF_PEN = new Intl.NumberFormat("es-PE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Formatea un monto como "S/ 1,234.56".
 * Acepta string (lo que el backend envía para Decimal) o number.
 */
export function formatPEN(amount: string | number | null | undefined): string {
  if (amount == null || amount === "") return "S/ 0.00";
  const n = typeof amount === "string" ? Number(amount) : amount;
  if (!Number.isFinite(n)) return "S/ 0.00";
  return `S/ ${NF_PEN.format(n)}`;
}

/** Convierte un Decimal-string del backend a number para mostrar. */
export function toNumber(value: string | number | null | undefined): number {
  if (value == null) return 0;
  return typeof value === "string" ? Number(value) : value;
}
